import React, { useState, useEffect } from 'react';
import { t } from '../i18n';

const API_BASE = '/api';

export default function Dashboard({ user }) {
  const [summary, setSummary] = useState(null);
  const [txCount, setTxCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    const headers = { Authorization: `Token ${user.token}` };
    fetch(`${API_BASE}/dashboard-summary/`, { headers }).then((r) => r.json()).then(setSummary).catch(() => {});
    fetch(`${API_BASE}/my-transactions/`, { headers }).then((r) => r.json()).then((d) => setTxCount((d.entries || []).length)).catch(() => {});
  }, [user]);

  if (!user) return <div style={{ padding: 20, textAlign: 'center' }}><h2>🔑 Login Required</h2></div>;
  if (!summary) return <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>{t('db_loading')}</div>;

  const cardStyle = { background: '#fff', border: '1px solid #E3E1D9', borderRadius: 12, padding: '1.2rem', textAlign: 'center' };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '1.5rem', fontFamily: 'sans-serif' }}>
      <h1 style={{ fontSize: 24, marginBottom: 2 }}>{t('db_title')}</h1>
      <p style={{ fontSize: 13, color: '#5F5E5A', marginBottom: 20 }}>{t('db_subtitle')}</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 12, marginBottom: 20 }}>
        <a href="#services" style={{ ...cardStyle, textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <p style={{ fontSize: 30, fontWeight: 700, color: '#0F6E56', margin: '0 0 4px' }}>{summary.services_count}</p>
          <p style={{ fontSize: 12, color: '#5F5E5A', margin: 0 }}>{t('db_services')}</p>
        </a>
        <a href="/my-transactions" style={{ ...cardStyle, textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <p style={{ fontSize: 30, fontWeight: 700, color: '#0F6E56', margin: '0 0 4px' }}>{txCount}</p>
          <p style={{ fontSize: 12, color: '#5F5E5A', margin: 0 }}>{t('db_invoices')}</p>
        </a>
        <a href="/support" style={{ ...cardStyle, textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <p style={{ fontSize: 30, fontWeight: 700, color: '#91600C', margin: '0 0 4px' }}>{summary.open_tickets}</p>
          <p style={{ fontSize: 12, color: '#5F5E5A', margin: 0 }}>{t('db_open_tickets')}</p>
        </a>
        <a href="/support" style={{ ...cardStyle, textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <p style={{ fontSize: 30, fontWeight: 700, color: '#5F5E5A', margin: '0 0 4px' }}>{summary.total_tickets}</p>
          <p style={{ fontSize: 12, color: '#5F5E5A', margin: 0 }}>{t('db_total_tickets')}</p>
        </a>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <a href="/my-transactions" style={{ padding: '8px 16px', fontSize: 13, fontWeight: 500, border: '1px solid #E3E1D9', borderRadius: 8, textDecoration: 'none', color: '#1F1E1B' }}>🧾 View Invoices</a>
        <a href="/support" style={{ padding: '8px 16px', fontSize: 13, fontWeight: 500, border: '1px solid #E3E1D9', borderRadius: 8, textDecoration: 'none', color: '#1F1E1B' }}>🎫 View Tickets</a>
        <a href="/cart" style={{ padding: '8px 16px', fontSize: 13, fontWeight: 500, border: '1px solid #E3E1D9', borderRadius: 8, textDecoration: 'none', color: '#1F1E1B' }}>🛒 My Cart</a>
      </div>

      <div id="services" style={{ background: '#fff', border: '1px solid #E3E1D9', borderRadius: 12, padding: '1.2rem' }}>
        <h3 style={{ fontSize: 15, marginBottom: 12 }}>{t('db_active_services')}</h3>
        {summary.services.length === 0 ? (
          <p style={{ fontSize: 13, color: '#999' }}>No active services yet - become a Merchant, Freelancer, Blue Tick member, or more to see them here.</p>
        ) : (
          summary.services.map((s, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: i < summary.services.length - 1 ? '1px solid #F1EFE8' : 'none' }}>
              <div>
                <p style={{ fontSize: 14, fontWeight: 500, margin: 0 }}>{s.icon} {s.name}</p>
              </div>
              <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 12, background: s.status === 'active' || s.status === 'approved' ? '#E1F5EE' : '#FBEAE3', color: s.status === 'active' || s.status === 'approved' ? '#0F6E56' : '#91600C', textTransform: 'capitalize' }}>
                {s.status}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
